import { ca } from '@cian/analytics';
import { getProductsData } from '../../selectors/analytics';
import { IPromo } from '../../types/newbuilding/promos';

export function trackCianMortgageClick(promo: IPromo, newbuildingId: number) {
  const { promoType, uniquePromoId: promoCianMortgage, promoId } = promo;

  ca('eventSite', {
    action: 'click_morgage',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId, promoCianMortgage })],
  });
}
